import {
  emptyNull,
  isJwtExpired,
  localStorageGetItem,
  pipe,
} from '../../misc';
import applyDefaults from './apply-defaults';

let state = emptyNull;

const validateExpireDate = ({ accessToken }) => {
  if (isJwtExpired(accessToken)) return null;

  return accessToken;
};

const fromStorage = (config) => {
  try {
    return pipe(
      localStorageGetItem,
      JSON.parse,
      validateExpireDate
    )(`${config.instance}.user`);
  } catch {
    return null;
  }
};

const manageState = {
  configure(config = emptyNull) {
    state = {
      ...applyDefaults(config),
      // since envJWTToken needs to be dynamically
      // fetched from storage, it has to be after apply defaults.
      get envJWTToken() {
        return fromStorage(config);
      }
    };
    return this;
  },
  get config() {
    return state;
  },
};

export default manageState;
